module.exports = __webpack_public_path__ + "static/media/jasper-menken.f088bbbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/featured/jasper-menken.jpg
// module id = 262
// module chunks = 0